module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-lightitalic-webfont.f2e1536b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-lightitalic-webfont.svg
// module id = 369
// module chunks = 3